import { useState } from "react";
import Button from "../Button/Button";
import { FormOptions } from "../FormOptions/FormOptions";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const Form = ({ formData, onComplete }) => {
  const { t } = useTranslation(["customQuestions", "questionsModule"]);
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [activeQuestion, setActiveQuestion] = useState(formData[0]);

  const loadDefault = () => {
    const initalOptionsValue = {};
    for (let i = 0; i < formData.length; i++) {
      switch (formData[i].type) {
        case "multi-options":
          initalOptionsValue[formData[i].Q] = [];
          break;
        default: // single-option
          initalOptionsValue[formData[i].Q] = "";
          break;
      }
    }
    return initalOptionsValue;
  };

  const [selectedOptions, setSelectedOptions] = useState(() => loadDefault());

  const onContinue = () => {
    if (activeQuestionIndex + 1 === formData.length) {
      trackEvent(
        `webapp_user_press_continue_question_${activeQuestionIndex + 1}`,
        uid,
      );
      onComplete(selectedOptions);
    } else {
      setActiveQuestionIndex((prevValue) => prevValue + 1);
      setActiveQuestion(formData[activeQuestionIndex + 1]);
      trackEvent(
        `webapp_user_press_continue_question_${activeQuestionIndex + 1}`,
        uid,
      );
    }
  };

  const handleSingleOptionInput = (value) => {
    setSelectedOptions((prevSelectedOption) => ({
      ...prevSelectedOption,
      [activeQuestion.Q]: value,
    }));
  };

  const handleMultiOptionInput = (value) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (value === activeQuestion.resetMapOption) {
        return {
          ...prevSelectedOptions,
          [activeQuestion.Q]: [value],
        };
      }

      let updatedOptions = [...prevSelectedOptions[activeQuestion.Q]];
      updatedOptions = updatedOptions.filter(
        (item) => item !== activeQuestion.resetMapOption,
      );

      const optionIndex = updatedOptions.indexOf(value);
      // Allow atleast one option to be always selected
      if (optionIndex !== -1 && updatedOptions.length === 1) {
        return {
          ...prevSelectedOptions,
          [activeQuestion.Q]: updatedOptions,
        };
      }

      if (optionIndex !== -1) {
        updatedOptions.splice(optionIndex, 1);
      } else {
        updatedOptions.push(value);
      }
      return {
        ...prevSelectedOptions,
        [activeQuestion.Q]: updatedOptions,
      };
    });
  };

  return (
    <>
      <div className="form-module-container">
        <h4 className="form-header">{t(activeQuestion.Q)}</h4>
        <div className="form-options-wrapper">
          <FormOptions
            options={activeQuestion.keyMapOptions}
            multiAllowed={activeQuestion.type === "multi-options"}
            selectedOptions={selectedOptions[activeQuestion.Q]}
            onSelect={
              activeQuestion.type === "multi-options"
                ? handleMultiOptionInput
                : handleSingleOptionInput
            }
          />
        </div>
      </div>
      <div className="question-module-btn-wrapper-top">
        <Button
          text={t("questionsModule:skip")}
          onClick={() => onContinue()}
          alternateColor={false}
          usePrimaryColor={false}
        />
      </div>
      <div className="question-module-btn-wrapper-bottom">
        <Button
          text={t("questionsModule:continue")}
          onClick={() => onContinue()}
          disabled={selectedOptions[activeQuestion.Q].length < 1}
        />
      </div>
    </>
  );
};
